// Shared `prefers-reduced-motion` query for Stimulus controllers.
//
// Mirrors the React-side helper at app/javascript/lib/text-stream.ts:72-75
// so the two surfaces honour the user's motion preference identically.
// Use this instead of inlining the matchMedia call — keeps the guard
// testable (single mock surface) and consistent across controllers.

export function prefersReducedMotion() {
  if (typeof window === "undefined" || !window.matchMedia) return false
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}
